"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListContent = void 0;
const React = require("react");
const mobx_react_1 = require("mobx-react");
const react_intl_1 = require("react-intl");
const list_item_1 = require("@festival/exponent/list-item");
const list_item_light_1 = require("@festival/exponent/list-item-light");
const reactstrap_1 = require("reactstrap");
const box_1 = require("@festival/tag/box");
const react_router_dom_1 = require("react-router-dom");
const classnames_1 = require("classnames");
const loader_1 = require("@festival/component/loader");
class ListContent extends React.Component {
    constructor(props) {
        super(props);
        if (this.props.exponentStore) {
            this.props.exponentStore.loadList();
        }
    }
    render() {
        const { exponentStore, routeManager, className } = this.props;
        if (!exponentStore || !routeManager) {
            return null;
        }
        const exponentsMainList = exponentStore.filteredAndOrderedExponentsInMainList;
        const exponentsSecondaryList = exponentStore.filteredAndOrderedExponentsNotInMainList;
        return this.renderContent(exponentsMainList, exponentsSecondaryList, routeManager, exponentStore.listNeverLoaded);
    }
    renderContent(exponentsMainList, exponentsSecondaryList, routeManager, listNeverLoaded) {
        const { className, exponentStore } = this.props;
        if (!exponentStore) {
            return null;
        }
        return (React.createElement("div", { id: "list-exponents", className: classnames_1.default(className) },
            React.createElement("div", { className: "d-flex flex-column justify-content-end align-items-center" },
                React.createElement("div", { className: "w-100" },
                    React.createElement(box_1.default, { type: "exponent", complete: this.tagBoxComplete, codes: exponentStore.tags })),
                React.createElement(react_router_dom_1.Link, { to: routeManager.generate('become_exponent'), className: "become-exponent-link ml-2 text-nowrap mb-2" },
                    React.createElement(react_intl_1.FormattedMessage, { id: "exponent.link.become-exponent" }))),
            exponentsMainList.length > 0 && (this.renderMainList(exponentsMainList)),
            exponentsSecondaryList.length > 0 && (this.renderSecondaryList(exponentsSecondaryList)),
            exponentsMainList.length === 0 && exponentsSecondaryList.length === 0 && listNeverLoaded && (React.createElement(loader_1.default, null)),
            exponentsMainList.length === 0 && exponentsSecondaryList.length === 0 && !listNeverLoaded && (React.createElement(reactstrap_1.Alert, { color: "warning" },
                React.createElement(react_intl_1.FormattedMessage, { id: "exponent.list.empty" })))));
    }
    renderMainList(exponents) {
        return (React.createElement(reactstrap_1.Row, { className: this.rowClass }, exponents.map((exponent, index) => (React.createElement(reactstrap_1.Col, { key: index, className: "mb-4" },
            React.createElement(list_item_1.default, { exponent: exponent }))))));
    }
    renderSecondaryList(exponents) {
        return (React.createElement(reactstrap_1.Row, { className: this.rowClassForSimple }, exponents.map((exponent, index) => (React.createElement(reactstrap_1.Col, { key: index, className: "mb-4" },
            React.createElement(list_item_light_1.default, { exponent: exponent }))))));
    }
    get tagBoxComplete() {
        return true;
    }
    get rowClass() {
        return 'row-cols-1 row-cols-md-2';
    }
    get rowClassForSimple() {
        return 'row-cols-1 row-cols-md-2 row-cols-lg-3';
    }
}
exports.ListContent = ListContent;
exports.default = mobx_react_1.inject('exponentStore', 'routeManager')(mobx_react_1.observer(ListContent));
